import { render, staticRenderFns } from "./iconCloseSvg.vue?vue&type=template&id=bc49fa98&"
import script from "./iconCloseSvg.js?vue&type=script&lang=js&"
export * from "./iconCloseSvg.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports